import React from "react";

import { templates } from "@reactivated";

import { Template as BaseTemplate } from "./FormPageTemplate";

export const Template = (props: templates.FormLandingPageTemplate) => {
    if (!props.is_preview) {
        throw new Error("This template should only be rendered in preview");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <BaseTemplate {...(props as any)} isSubmitted />;
};
